import { FilterOperations as FO } from 'business/definitions';

export const dynamicYearFilterValue = {
    current: 'current',
    last: 'last',
    next: 'next',
};

export const isDynamicYearFilter = (value: string) =>
    Object.values(dynamicYearFilterValue).includes(value);

export const nestedYearFilterOperations: FilterOperationsT[] = [
    FO.equal,
    FO.not_equal,
    FO.greater_or_equal,
    FO.lower_or_equal,
];
